import { http_client } from '@/plugins/http_client';

const API_BASE = '/api/consultorias';

export const fetchEstadosEntregables = () => {
  return http_client(`${API_BASE}/entregables/estados`, {}, 'GET');
};

export const fetchEntregables = (id = null, params = {}) => {
  const url = `${API_BASE}/entregables/filtrar/${id}`;
  return http_client(url, params, 'POST');
};

export const guardarEntregable = (data = {}) => {
  return http_client(`${API_BASE}/entregables`, data, 'POST');
};

export const actualizarEntregable = (data = {}) => {
  return http_client(`${API_BASE}/entregables/editar`, data, 'PUT');
};

export const eliminarEntregable = (id = null, params = {}) => {
  const url = `${API_BASE}/entregables/eliminar/${id}`;
  return http_client(url, params, 'DELETE');
};

export const descargarPlantilla = () => {
  return http_client(
    `${API_BASE}/entregables/descargar-plantilla`,
    {},
    'GET',
    {},
    true,
    'blob'
  );
};

export const importarEntregables = formData => {
  return http_client(`${API_BASE}/entregables/importar`, formData, 'POST', {
    'Content-Type': 'multipart/form-data',
  });
};

// vista detalle entregable

export const fetchDetalleEntregable = (id, params = {}) => {
  return http_client(
    `${API_BASE}/entregables/ver-detalle/${id}`,
    params,
    'POST'
  );
};

// vista designar consultores

export const fetchConsultoresDesignados = id => {
  return http_client(`${API_BASE}/entregables/${id}/consultores`, {}, 'GET');
};

// vista designar consultores

export const fetchNominasNoAsignado = (id, params = {}) => {
  return http_client(
    `${API_BASE}/entregables/listar-nominas/${id}`,
    params,
    'POST'
  );
};

// carga informacion de cada consultor
export const fetchConsultor = id => {
  return http_client(`${API_BASE}/mnt/nomina/${id}`, {}, 'GET');
};
// id consultor

export const asignarEmpleadosEntregable = (entregableId, data) => {
  return http_client(
    `${API_BASE}/entregables/actualizar-empleados/${entregableId}`,
    data,
    'POST'
  );
};

// export const fetchFotoConsultor = id => {
//   const baseUrl = process.env.VUE_APP_URL_API_BOLSA_EMPLEO;
//   return this.$axios.get(`${baseUrl}/api/v1/documento/persona/get-foto/${id}`);
// };

export const cerrarEntregables = (consultoria_id = 0) => {
  const data = {
    consultoria_id,
  };

  return http_client(
    `${API_BASE}/entregables/cierre-entregables`,
    data,
    'POST'
  );
};

export const fetchEntregablesAVencer = () => {
  return http_client(
    `${API_BASE}/entregables/notificar-vencimiento`,
    {},
    'GET'
  );
};

export const fetchHistorialPagos = nominaId => {
  return http_client(`${API_BASE}/nomina/${nominaId}/entregables`, {}, 'GET');
};

export default {
  fetchEstadosEntregables,
  fetchEntregables,
  guardarEntregable,
  actualizarEntregable,
  eliminarEntregable,
  descargarPlantilla,
  importarEntregables,
  fetchDetalleEntregable,
  fetchConsultoresDesignados,
  fetchNominasNoAsignado,
  fetchConsultor,
  asignarEmpleadosEntregable,
  cerrarEntregables,
  // fetchFotoConsultor,
  fetchEntregablesAVencer,
  fetchHistorialPagos,
};
